import { PageLayout } from "~/components/PageLayout";
import { CasesList } from "~/features/cases/components/CasesList";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const CasesPage = () => {
  useTrackPageVisit("app/cases/visit");

  return (
    <PageLayout>
      <CasesList />
    </PageLayout>
  );
};
